<template>
  <b-modal id="modal-cannot-add-widget-in-slide" header-class="warning">
    <template #modal-header>
      <div class="d-inline-flex justify-content-between w-100">
        <div class="w-100"> 
          <h5>{{$t("engine.modal.canNotAddWidgetInSlide.lblTitle", languageEngine)}}</h5>
        </div>
      </div>
      <div class="close px-2" type="button" style="font-size: 18px">
      </div>
      <div
        @click="closeModal()"
        type="button"
        aria-label="Close"
        id="close-modal-cannot-add-widget-in-slide"
        class="close-modal"
      >
        <i class="fal fa-times"></i>
      </div>
    </template>
    <template>
      <div>
        {{$t("engine.modal.canNotAddWidgetInSlide.lblDetail", languageEngine)}}
      </div>
    </template>
    <template #modal-footer>
      <div class="float-right">
        <b-button variant="blue" @click="closeModal">{{$t("engine.modal.canNotAddWidgetInSlide.btnOk", languageEngine)}}</b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters({
      modal: "design/modal",
      languageEngine: "design/userPreference/languageEngine",
    }),
  },
  methods: {
    closeModal() {
      this.$bvModal.hide("modal-cannot-add-widget-in-slide");
      this.$store.dispatch("design/setModal", { name: "" });
    }
  },
  watch: {
    modal: {
      handler() {
        if (this.modal == "modal-cannot-add-widget-in-slide") {
          this.$bvModal.show("modal-cannot-add-widget-in-slide");
        }
      },
    },
  }
}
</script>